import { Component, OnInit, ElementRef, Input, Output, EventEmitter, OnDestroy } from '@angular/core';

@Component({
  selector: 'wfm-infinity-scroll',
  template: '<ng-content></ng-content>'
})
export class InfinityScrollComponent implements OnInit, OnDestroy {
  private ready = false;

  private $direction: string;
  private lastScrollTop = 0;
  private lastScrollLeft = 0;

  @Input()
  set direction(direction: string) {
    direction = direction.toLowerCase();
    if (direction === 'vertical' || direction === 'horizontal') {
      this.$direction = direction;
      this.updateDirection();
    }
  }

  get direction(): string {
    return this.$direction || 'vertical';
  }

  @Input()
  edgeDistance = 0;

  @Output()
  edgeDistanceHit = new EventEmitter();

  constructor(public element: ElementRef) {}

  private updateDirection() {
    if (!this.ready) {
      return;
    }

    if (this.direction === 'horizontal') {
      this.element.nativeElement.style.overflowX = 'auto';
      this.element.nativeElement.style.overflowY = 'hidden';
      this.element.nativeElement.style.whiteSpace = 'nowrap';
    } else {
      this.element.nativeElement.style.overflowX = 'hidden';
      this.element.nativeElement.style.overflowY = 'auto';
      this.element.nativeElement.style.whiteSpace = 'none';
    }
  }

  eventListener = () => {
    let scrollingToEdge = false;
    const scrollTop = this.element.nativeElement.scrollTop;
    const scrollLeft = this.element.nativeElement.scrollLeft;
    let distanceToEdge = 0;

    // if scrolling down
    if (scrollTop > this.lastScrollTop && this.direction === 'vertical') {
      scrollingToEdge = true;
      distanceToEdge =
        this.element.nativeElement.scrollHeight -
        this.element.nativeElement.offsetHeight -
        this.element.nativeElement.scrollTop;
    }

    // if scrolling right
    if (scrollLeft > this.lastScrollLeft && this.direction === 'horizontal') {
      scrollingToEdge = true;
      distanceToEdge =
        this.element.nativeElement.scrollWidth -
        this.element.nativeElement.offsetWidth -
        this.element.nativeElement.scrollLeft;
    }

    if (scrollingToEdge && distanceToEdge <= this.edgeDistance) {
      this.edgeDistanceHit.emit();
    }

    this.lastScrollTop = scrollTop;
    this.lastScrollLeft = scrollLeft;
  };

  ngOnInit() {
    this.ready = true;

    this.updateDirection();

    this.element.nativeElement.style.position = 'absolute';
    this.element.nativeElement.style.top = '0';
    this.element.nativeElement.style.bottom = '0';
    this.element.nativeElement.style.left = '0';
    this.element.nativeElement.style.right = '0';
    this.element.nativeElement.style.margin = '0';
    this.element.nativeElement.style.padding = '0';

    this.element.nativeElement.addEventListener('scroll', this.eventListener);
  }

  ngOnDestroy() {
    this.element.nativeElement.removeEventListener('scroll', this.eventListener);
  }
}
